import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  isEnabled(flag: keyof typeof environment.features): boolean {
    return !!environment.features[flag];
  }
}